export class Zeugnis {
  public artDesZeugnis = '';
  public anrede = '';
  public vorname = '';
  public nachname = '';
  public dateOfBirth: string | null = null;
  public einstellungsdatum = '';
  public enddatum = '';
  public rolle = '';
  public firma = '';
  public letzteProjektrolle = '';
  public aufgaben: string[] = [];
  public werkzeuge: string[] = [];
  public fachwissen = '';
  public weiterbildung = '';
  public auffassungsgabe = '';
  public leistungsbereitschaft = '';
  public belastbarkeit = '';
  public arbeitsweise = '';
  public zuverlaessigkeit = '';
  public arbeitsergebnis = '';
  public zusammenfassendeBeurteilung = '';
  public verhalten = '';
  public schlussformulierung = '';
  public beurteilung = '';
  public grundDesZeugnisses = '';
  public verabschiedung = '';
}
